import axios from 'axios'
import { mockClient } from './cardLinkApiClientMock'
import { cardLinkApiClientBaseUrl } from '@/src/card-linking/api-client/cardLinkApiClientBaseUrl'
// import { loadEnvConfig } from '@next/env'
//
// loadEnvConfig(
//     process.cwd(),
//     ['dev', 'development'].includes(process.env.NODE_ENV ?? ''),
// )

export const liveClient = axios.create({
    baseURL: cardLinkApiClientBaseUrl,
    headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
    },
})

const useMock = Boolean(
    parseInt(String(process.env.NEXT_PUBLIC_AXIOS_MOCK_CARD_LINK))
)
export const cardLinkApiClient = useMock ? mockClient : liveClient
